import { redirect } from "@client/actions";
import { globals } from "@client/globals";
import { getCart } from "@client/lib/cookie";
import { connectCustom } from "@client/lib/misc";
import { siteColorSelector } from "@client/selectors";
import { type AppState, type WithClassName } from "@client/types";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: Partial<WithClassName>): MapProps => {
    const cart = getCart(state.portal.id);
    return {
      ...props,
      color: siteColorSelector(state),
      itemCount: cart ? cart.items?.reduce((res, x) => res + x.quantity, 0) ?? 0 : 0,
      isEditMode: state.isEditMode
    };
  };
};

const mapDispatchToProps = (dispatch: any): ActionProps => ({
  goToCart: () =>
    dispatch(
      redirect({
        redirectTo: {
          pageId: globals.siteInfo.cartPageId,
          newTab: false,
          type: "tab"
        }
      })
    )
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
